/**
 * Available global system user role types.
 */
export type MobizSystemRole =
  /**
   * System Administrator.
   */
  'Administrator' |
  /**
   * Standard user.
   */
  'User';
